// Availability is reviewed separately from prices and management style.
// A price refresh must never renew this evidence. The daily source check
// (server/availability-check.mjs) flags changed sources between reviews.
export const AVAILABILITY_VALID_DAYS = 90;
export function availabilityExpiresAt(fund) {
  const checked = Date.parse(fund?.availability?.checkedAt);
  return Number.isFinite(checked) ? new Date(checked + AVAILABILITY_VALID_DAYS * 86400000) : null;
}
export function availabilityStatus(fund, now = new Date()) {
  const a = fund?.availability;
  if (!a) return 'unconfirmed';
  if (['closed','restricted'].includes(a.status)) return a.status;
  const checked = Date.parse(a.checkedAt), time = +new Date(now);
  if (a.status !== 'open' || a.audience !== 'hr-retail' || !/^https:\/\//.test(a.sourceUrl || '') || !Number.isFinite(checked) || checked > time || time - checked > AVAILABILITY_VALID_DAYS * 86400000) return 'unconfirmed';
  if (a.subscriptionEnd && (!/^\d{4}-\d{2}-\d{2}$/.test(a.subscriptionEnd) || !Number.isFinite(Date.parse(a.subscriptionEnd)) || time > Date.parse(a.subscriptionEnd+'T23:59:59+01:00'))) return 'closed';
  if (fund.maturityDate && time >= Date.parse(fund.maturityDate)) return 'closed';
  return 'open';
}
export const isInvestable = (fund, now) => availabilityStatus(fund, now) === 'open';
export function availabilityLabel(fund, now) {
  return {open:'Dostupan za nove uplate građana',closed:'Zatvoren za nove uplate',restricted:'Nije dostupan građanima u Hrvatskoj',unconfirmed:'Dostupnost za nove uplate nije potvrđena'}[availabilityStatus(fund,now)];
}
export const AVAILABILITY_NOTE = 'Prikazujemo samo fondove s potvrđenim novim uplatama za građane u Hrvatskoj. Dostupnost vrijedi prema navedenom datumu provjere; uvjeti i minimalna uplata ovise o fondu i distributeru.';
